var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"align-center justify-center",attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"align":"center","align-self":"center","cols":"12","sm":"12","md":"12","lg":"12"}},[_c('div',{attrs:{"id":"container"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }